import { apiRequest } from "../util/apiUtils";

export const activityList = async (params) => {
  try {
    const res = await apiRequest("get", `activity/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
